var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',[_c('div',{staticClass:"item-header"},[_vm._v("\n    "+_vm._s(_vm.$l.infoFromCompany)+"\n  ")]),_vm._l((_vm.infos),function(info,index){return _c('info-cell',{key:index,attrs:{"info":info}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }